import { AfterViewInit, Component, inject, OnDestroy, ViewChild } from "@angular/core";
import { OrganisationService } from "../../organisation/organisation.service";
import { ActivatedRoute, Router } from "@angular/router";
import { LinqsetRepositoryService } from "../../model-services/linqset-repository.service";
import { canChangeInsightsFilter, cloneInsightsfilter, createInsightsFilter, findTagForOrganisation, InformationAsset, InsightsFilter, MODEL_FUNCTION, ModelDetails, Organisation } from "../../common/organisation";
import { Subscription } from "rxjs";
import { addNodeInsights, createNewNodeInsights, CURRENT_STATE_PROJECT_KEY, FILTER_MODEL_KEY, getSuperType, getTypeForSuperType, getTypeName, INSIGHTS_SECTION, isOrganisationNode, isRolePeople, isRoleSystem, isSystemInfrastructure, Linqset, LINQSET_TYPE, LinqsetNode, MODEL_TYPE, NODE_SUPERTYPE, NODE_TYPE, ORGANISATION_MODEL_KEY } from "../../common/linqset-model";
import { SCREEN } from "../layouts-enums";
import { processLinqset, createLinqset } from "../../common/model-processing";
import { filterNodesForLinqset } from "../../analysis/scope-linqset.service";
import { InsightsService } from "../../model-services/insights.service";
import { SidenavService } from "../model/sidenav.service";
import { GroupItem, GroupSelectionComponent, ItemSelection } from "../../ui-components/group-selection/group-selection.component";
import { TagsService } from "../../organisation/tags/tags-service";
import { NodeInsightsTypeData } from "../../insights/node-types/node-types-insights.component";
import { MatDialog } from "@angular/material/dialog";
import { NodeDialogComponent } from "../../model-components/nodes/node-dialog.component";
import { AppComponent } from "../../app.component";
import { SKETCH_URL } from "../../app-urls";
import { FUNCTION, FunctionService } from "../../model-services/function.service";
import { IModelItem, INode } from "@yfiles/yfiles";
import { LabelService } from "../../model-services/label.service";
import { GraphComponentComponent } from "../../canvas/graph-component/graph-component.component";
import { HelpOverlay, HelpService } from "../../help/help-services";
import { UserService } from "../../user/user.service";
import { ONBOARDING_STEPS, User, USER_ROLE } from "../../common/user";
import { ConfirmDialogComponent, ConfirmDialogModel } from "../../ui-components/dialogs/confirm-dialog.component";
import { lastValueFrom } from "rxjs";
import { MatSnackBar } from "@angular/material/snack-bar";
import { InsightsOverviewComponent } from "../../insights/insights-overview-component";
import { MatSidenav } from "@angular/material/sidenav";
import { GraphService } from "../../canvas/graph.service";
import { NodeService } from "../../model-services/node.service";

@Component({
    selector: 'app-insights-layout',
    templateUrl: './insights-layout.html',
    styleUrls: ['./insights-layout.scss'],
    standalone: false
})
export class InsightsLayoutComponent implements AfterViewInit, OnDestroy {
    sidebarOpen = true
    querySub:Subscription
    screen:SCREEN = SCREEN.INSIGHTS
    organisation:Organisation

    organisationKey:string
    routeSub:Subscription

    linqset: Linqset
    comparison: Linqset
    user:User

    superTypes:NODE_SUPERTYPE[] = [NODE_SUPERTYPE.ROLE, NODE_SUPERTYPE.SYSTEM, NODE_SUPERTYPE.INFRASTRUCTURE, NODE_SUPERTYPE.PEOPLE, NODE_SUPERTYPE.OUTCOMES]

    typeData:NodeInsightsTypeData[]

    // used to populate filter dropdowns
    groupedNodes:GroupItem[]
    nodes:LinqsetNode[]
    selectedNodes: LinqsetNode[] = []
    informationAssetKey:string               // selected info asset key

    informationAssets:InformationAsset[]        // list of assets
    filters:GroupItem[]            // list of existing filters to select from

    modelType:MODEL_TYPE

    // select lists
    modelsData:GroupItem[]
    captures:GroupItem[]
    outcomes:GroupItem[]
    tags:GroupItem[]
    workspaces:any[]

    loading = false

    filter:InsightsFilter               // filter used to create linqset

    filterKey:string
    startModelKey:string
    startWorkspaceKey:string
    returnModelKey:string

    nodeSelectionChanged:boolean = false
    reloadTrigger:any

    NODE_SUPERTYPE = NODE_SUPERTYPE
    CURRENT_STATE_PROJECT_KEY = CURRENT_STATE_PROJECT_KEY
    INSIGHTS_SECTION = INSIGHTS_SECTION
    FUNCTION = FUNCTION

    filterUrl:string = ''

    readonly dialog = inject(MatDialog);
    @ViewChild(GraphComponentComponent) insightsGraphComponent: GraphComponentComponent

    @ViewChild("insightsOverview") insightsOverview:InsightsOverviewComponent
    @ViewChild("filterselection") filterSelection: GroupSelectionComponent
    @ViewChild("tagselection") tagSelection: GroupSelectionComponent
    @ViewChild('rightdrawer') public rightDrawer: MatSidenav;

    constructor(public organisationService:OrganisationService, public linqsetRepo: LinqsetRepositoryService, private route:ActivatedRoute, private router:Router, private graphService:GraphService,
        private labelService:LabelService, private functionService:FunctionService, private userService:UserService, private snackBar:MatSnackBar, private nodeService:NodeService,
        private insightsService:InsightsService, public sidenavService:SidenavService, private tagService:TagsService, private helpService:HelpService) {
    }

    async ngAfterViewInit(): Promise<void> {
        if (!this.routeSub) {
            setTimeout(() => {
                this.querySub = this.route.queryParams.subscribe(async p => {
                    this.startModelKey = p['modelKey']
                    this.startWorkspaceKey = p['workspaceKey']
                    this.returnModelKey = this.startModelKey

                    this.filterKey = p['filterKey']
                })

                this.routeSub = this.route.params.subscribe(async p => {
                    this.organisationKey = p['organisation_key']

                    await this.initialiseData()
                })
            })
        }
    }

    ngOnDestroy(): void {
        // a screen tour points at this page, so it ends when the page goes
        this.helpService.endTour()
        if (this.routeSub) this.routeSub.unsubscribe()
        if (this.querySub) this.querySub.unsubscribe()
    }

    // the filter panel takes less room on narrower screens
    get sidebarWidth() {
        return Math.round(Math.min(400, Math.max(300, window.innerWidth * 0.3)))
    }

    toggleSidebar() {
        this.sidebarOpen = !this.sidebarOpen
    }

    // the owner can change or delete a saved filter, and organisation admins can change shared ones
    canChangeFilter() {
        return canChangeInsightsFilter(this.filter, this.user?._key, this.organisation?.role, this.userService.isSysAdmin())
    }

    isSavedFilter() {
        return !!this.filter?._key
    }

    insightsCompleted() {
        if (this.filterKey && this.filterKey.length > 0 && this.insightsOverview) {
            this.filterSelection.setSelection(this.filterKey)
            this.filterKey = undefined
        }
    }

    isHelpOn() {
        return AppComponent.help
    }

    getNodeSelectionHint() {
        if (this.filter.nodeType === NODE_TYPE.OUTCOMES) return "Will include all nodes upstream of selected outcome"
        if (this.filter.nodeType === NODE_TYPE.CAPTURE) return "Will include all nodes downstream of selected capture"
        return "Include all nodes attached to selected node"
    }

    handleItemDoubleClicked(item:IModelItem) {
        if ((item instanceof INode) && item.tag && item.tag.node) {
            this.openNodeDialog(item as INode)
        }
    }

    handleSelectNodeEvent(event) {
        const nodes = this.insightsGraphComponent.graphComponent.graph.nodes.filter(n => n.tag && n.tag.node && n.tag.node._key === event)
        if (nodes) this.graphService.selectModelItems(this.insightsGraphComponent.graphComponent, nodes.toArray())
    }

    returnToModel() {
        if (this.returnModelKey) this.router.navigateByUrl(SKETCH_URL(this.organisationKey, this.returnModelKey, (this.returnModelKey===ORGANISATION_MODEL_KEY?MODEL_TYPE.MODELS:MODEL_TYPE.PROCESS), this.startWorkspaceKey||CURRENT_STATE_PROJECT_KEY))
    }

    showConfirmation() {
        this.snackBar.open("Filter URL copied. Share the filter by Pasting in an email or message. They must have access to LINQ.", "close")
    }

    openNodeDialog(node:INode): void {
        const data = {node, graph:this.insightsGraphComponent?.graphComponent?.graph, linqset: this.linqset, organisation:this.organisation, organisationLinqset:this.linqsetRepo.organisationLinqset}

        const dialogRef = this.dialog.open(NodeDialogComponent, {data, width:'700px', hasBackdrop:true});
        dialogRef.afterClosed().subscribe(() => {
            // a failed save has been reported, and its changes stay on the model to save again
            if (this.linqset.isDirty()) this.linqsetRepo.saveLinqset(this.linqset).catch(() => {})
        });
    }

    public async handleFunctionEvent(event:{function:FUNCTION, value?:any}) {
        try {
            this.loading = true
            if (event.function === FUNCTION.SCREEN_TOUR) {
                this.showWhatsThisHelp()
            }else if (event.function === FUNCTION.CHANGE_MODEL_TYPE) {
                this.modelType = event.value
            }else if (event.function === FUNCTION.TOGGLE_TEMPORAL_MODEL) {
                if (this.rightDrawer.opened)
                    this.rightDrawer.close()
                else this.rightDrawer.open()
            }else await this.functionService.executeFunction(event.function, event.value, this.linqset, this.linqset.project, this.insightsGraphComponent.graphComponent, this.insightsGraphComponent)
        }catch(err) {
            console.error(err)
        }finally {
            this.loading = false
        }
    }


    showWhatsThisHelp() {
        const elements = [
            new HelpOverlay("menu", "<b>Main menu bar:</b> Navigation, management and search functions. Hover over items to see more detail.", {originX:'center', originY:'bottom', overlayX:'center', overlayY:'top'}),
            new HelpOverlay("mat-mdc-tab-header", "<b>Insights panel:</b> Shows insights for the current model. Select the tabs to see different information.", {originX:'center', originY:'bottom', overlayX:'center', overlayY:'top'}),
            new HelpOverlay("toolbar", "<b>Toolbar:</b> Tools for changing the view of the selected model. Hover over icons to see more detail.", {originX:'center', originY:'bottom', overlayX:'center', overlayY:'top'}),
            new HelpOverlay("filter", "<b>Filter:</b> Choose the workspace, models and nodes to show the model and insights for.", {originX:'center', originY:'bottom', overlayX:'center', overlayY:'top'}),
            new HelpOverlay("graph", "<b>Model canvas:</b> View the model generated based on the selected filter.", {originX:'center', originY:'center', overlayX:'center', overlayY:'center'}),
            new HelpOverlay("workspaces-menu", "<b>Workspaces menu:</b> Shows the current workspace. Open it to switch between current state and a project or future state.", {originX:'start', originY:'center', overlayX:'end', overlayY:'center'}),
            new HelpOverlay("models-menu", "<b>Models menu:</b> Shows the current model. Open it to switch to a different model.", {originX:'start', originY:'center', overlayX:'end', overlayY:'center'}),
            new HelpOverlay("help-menu", "<b>Help menu:</b> Help videos, tutorials and documentation.", {originX:'start', originY:'center', overlayX:'end', overlayY:'center'}),
            new HelpOverlay("home-button", "<b>Organisation home button:</b> Navigate to the organisation dashboard.", {originX:'end', originY:'center', overlayX:'start', overlayY:'center'})
        ]
        this.helpService.showWhatsThisOverlay(elements)
    }

    graphItemDoubleClickHandler(item:IModelItem) {
        if (item instanceof INode) {
            if (this.insightsGraphComponent.graphComponent.graph.isGroupNode(item) || item.tag?.group)
                this.insightsGraphComponent.toggleGroupNode(item)
            else if (item.tag && item.tag.model) this.openModel(item.tag.model)
            else NodeDialogComponent.open(this.dialog, this.organisation, this.insightsGraphComponent.graphComponent, this.linqset, this.linqsetRepo.organisationLinqset, item)
        }
    }

    openModel(model:ModelDetails) {
        if (model.role >= 0)
            this.router.navigateByUrl(SKETCH_URL(this.organisation._key, model._key,MODEL_TYPE.PROCESS, this.linqset?.workspaceKey))
        else
            this.snackBar.open("You do not have access to this model. You will need to request access from the owner.", "close");
    }

    private async initialiseData() {
        this.loading = true

        try {
            this.user = this.userService.getUser()

            await this.organisationService.checkOrganisationDataForRoute(this.organisationKey)
            this.organisation = this.organisationService.organisation
            if (!this.organisation.insightsFilters) this.organisation.insightsFilters = []

            // new filter
            this.filter = createInsightsFilter(this.startWorkspaceKey || CURRENT_STATE_PROJECT_KEY, this.user._key)
            if (this.startModelKey && this.startModelKey !== ORGANISATION_MODEL_KEY) this.filter.modelKeys.push(this.startModelKey)

            // setup list of workpsaces can select from
            this.workspaces = this.organisation.projects.filter(p => p.role)
            this.workspaces.splice(0, 0, {_key:CURRENT_STATE_PROJECT_KEY, name:"Current state"})

            // load organisation graph (roles, systems etc.)
            await this.loadOrganisationData(this.startWorkspaceKey)

            this.setupFilters()
            this.setupControls()

            // check if first time user
            if (!this.user.onboardingSteps || this.user.onboardingSteps.indexOf(ONBOARDING_STEPS.FIRST_INSIGHTS) < 0) {
                this.userService.saveOnboardingStep(ONBOARDING_STEPS.FIRST_INSIGHTS)
                this.showWhatsThisHelp()
            }

            if (this.filterKey && this.filterKey.length > 0) {
                this.selectFilterKey(this.filterKey)
            }

        }catch(err) {
            console.error(err)
        }finally {
            this.loading = false
        }
    }

    async loadOrganisationData(workspaceKey:string) {
        await this.linqsetRepo.loadModelData(this.organisation._key, ORGANISATION_MODEL_KEY, workspaceKey, false)
    }

    private setupFilters() {
        this.filters = [new GroupItem("private", undefined, "Private", undefined, false, undefined, this.organisation.insightsFilters.filter(f => f.private).map(f => {return new GroupItem(f._key, 'private', f.name, undefined, this.filter._key===f._key)}),
                ), new GroupItem("organisation", undefined, "Organisation", undefined, false, undefined, this.organisation.insightsFilters.filter(f => !f.private).map(f => {return new GroupItem(f._key, 'organisation', f.name, undefined, this.filter._key===f._key)}))
            ]
    }

    private async setupControls() {
        try {
            this.tags = this.organisation.tagGroups.map(tg => {
                return new GroupItem(tg._key, undefined, tg.name, undefined, false, undefined, tg.tags.map(t => {return new GroupItem(t._key, tg._key, t.name, this.tagService.getIconForTag(t), this.filter.nodeTags.indexOf(t._key)>=0)}))
            })

            this.setModelsData()
            if (this.insightsOverview)
                this.insightsOverview.setupSectionsAndFields(this.filter)

            this.runFilter(true)

        }catch(err) {
            console.error(err)
        }finally {
            this.loading = false
        }
    }

    setModelsData() {
        const functions:MODEL_FUNCTION[] = []
        this.modelsData = []
        const projectChangedGroup = new GroupItem("changed", undefined, "Changed models", undefined, false, undefined, [])
        const modelsGroup = new GroupItem("models", undefined, "Models", undefined, false, undefined, [])

        this.getOrganisationModels().filter(m => m.role).sort((a,b) => a.name.toLowerCase() > b.name.toLowerCase()?1:-1).forEach(m => {
            if (functions.indexOf(m.function) < 0) functions.push(m.function)
            const selected:boolean = this.filter.modelKeys.indexOf(m._key) >= 0
            const item = new GroupItem(m._key, undefined, m.name, undefined, selected)
            if (this.filter.workspaceKey !== CURRENT_STATE_PROJECT_KEY && m.projects.indexOf(this.filter.workspaceKey)>=0) {
                item.parentKey = projectChangedGroup._key
                projectChangedGroup.items.push(item)
            }else {
                item.parentKey = modelsGroup._key
                modelsGroup.items.push(item)
            }
        })
        this.startModelKey = undefined

        // clear this so only used first time
        if (this.filter.workspaceKey !== CURRENT_STATE_PROJECT_KEY) this.modelsData.push(projectChangedGroup)
        this.modelsData.push(modelsGroup)
        this.modelsData.push(new GroupItem("functions", undefined, "Model functions", undefined, false, undefined, functions.map(f => {return new GroupItem(f, "functions", f, undefined, this.filter.modelFunctions.indexOf(f)>=0)})))
        if (this.organisation.modelTags) this.modelsData.push(new GroupItem("tags", undefined, "Model tags", undefined, false, undefined, this.organisation.modelTags.tags.map(t => {return new GroupItem(t._key, "tags", t.name, this.tagService.getIconForTag(t), this.filter.modelTags.indexOf(t._key)>=0)})))
    }

    setTypeData() {
        const modelKeys = this.linqset.modelKeys

        this.filter.nodeType = undefined
        this.groupedNodes = []
        this.nodes = []
        this.selectedNodes = []

        if (this.linqset.type === LINQSET_TYPE.MODEL_FILTER) {
            const workspaceKey = this.filter.workspaceKey || CURRENT_STATE_PROJECT_KEY
            const typeMap = this.linqsetRepo.organisationLinqset.nodes.filter(n => !n.excluded).reduce((m, n) => {
                if (isRolePeople(n.superType) || isSystemInfrastructure(n.superType)) {
                    const filteredArray = n.insights.filter(i => i.projectKey === workspaceKey && modelKeys.indexOf(i.modelKey) >= 0)
                    if (filteredArray.length > 0) {
                        const t = this.nodeService.getNodeTypeForSuperType(n.superType).type

                        if (!m[t]) m[t] = new NodeInsightsTypeData(n.superType, t, this.filter.nodeType===t)
                        m[t].nodes.push(n)
                    }
                }else if (n.type === NODE_TYPE.CAPTURE || n.superType === NODE_SUPERTYPE.OUTCOMES) {
                    if (modelKeys.indexOf(n.modelKey) >= 0 && n.insights.find(i => i.projectKey === workspaceKey)) {
                        if (!m[n.type]) m[n.type] = new NodeInsightsTypeData(n.superType, n.type, this.filter.nodeType===n.type)
                        m[n.type].nodes.push(n)
                    }
                }
                return m
            }, {})
            this.typeData = Object.values(typeMap)
        }else {
            this.typeData = this.superTypes.filter(st => this.linqset.isOrganisationModel() || isRoleSystem(st) || st === NODE_SUPERTYPE.OUTCOMES).map(st => {
                const t = getTypeForSuperType(st)
                const d =  new NodeInsightsTypeData(st, t, this.filter.nodeType===t)
                d.nodes = this.linqset.nodes.filter(n => n.superType === st)
                return d
            })

            const captureType = new NodeInsightsTypeData(NODE_SUPERTYPE.ACTION, NODE_TYPE.CAPTURE, this.filter.nodeType===NODE_TYPE.CAPTURE)
            captureType.nodes = this.linqset.nodes.filter(n => !n.excluded && n.type === NODE_TYPE.CAPTURE)
            this.typeData.push(captureType)
        }

        if (this.filter.nodeType) {
            const td = this.typeData.find(t => t.type === this.filter.nodeType)
            if (td) this.selectType(td)
        }

        if (this.organisation.informationAssets) {
            this.informationAssets = modelKeys.length>0?this.organisation.informationAssets.filter(ia => {
                    return modelKeys.find(mk => {
                        const model = this.organisation.models.find(m => m._key === mk)
                        const modelInsights = model?.insights?.find(mi => mi.projectKey === this.filter.workspaceKey)
                        return modelInsights?.informationAssets?.find(ia2 => ia2.groupKey === ia._key)
                    })
                }):this.organisation.informationAssets.map(ia => ia)

            this.informationAssetKey = this.filter.informationAssetKeys.length>0?this.filter.informationAssetKeys[0]:undefined

        }else this.informationAssets = []

        this.informationAssets.unshift({_key:undefined, name:"All assets", description:""})
    }

    async onWorkspaceChange(selection:string) {
        if (selection === CURRENT_STATE_PROJECT_KEY && this.linqsetRepo.currentStateOrganisationLinqset) {
            this.linqsetRepo.organisationLinqset = this.linqsetRepo.currentStateOrganisationLinqset
        }else {
            await this.loadOrganisationData(selection)
        }
        this.setTypeData()
        this.clearFilters(selection)
    }

    clearFilters(workspaceKey:string = this.filter?.workspaceKey) {
        this.filter = createInsightsFilter(workspaceKey, this.user._key)
        this.filterUrl = ''
        this.filterSelection.clearSelection()
        this.clearInformationAssetSelection()
        this.clearNodeSelection()
        this.clearTagSelection()
        this.setupControls()
    }

    selectFilter(f:ItemSelection) {
        this.selectFilterKey(f.item._key)
    }

    // works on a copy, so changes aren't kept unless the filter is saved
    async selectFilterKey(k:string) {
        const saved = this.organisation.insightsFilters.find(of => of._key === k)
        if (!saved) {
            this.snackBar.open("That filter no longer exists, or is private to someone else.", "close", {duration:6000})
            return
        }
        this.filter = structuredClone(saved)
        this.filterUrl = this.createFilterUrl(this.filter)

        // the filter may be for a different workspace to the one loaded
        const workspaceKey = this.filter.workspaceKey || CURRENT_STATE_PROJECT_KEY
        if (this.linqsetRepo.organisationLinqset?.workspaceKey !== workspaceKey) {
            this.loading = true
            try {
                await this.loadOrganisationData(workspaceKey)
            }finally {
                this.loading = false
            }
        }
        this.setupControls()
    }

    private createFilterUrl(filter:InsightsFilter) {
        return window.location.href.split('?')[0] + '?filterKey=' + filter._key
    }

    getOrganisationModels() {
        return this.organisation.models.filter(m => {
            // return all current state and project models
            return (m.projectKey === CURRENT_STATE_PROJECT_KEY || this.filter.workspaceKey === m.projectKey) && !m.deletedDate
        })
    }

    toggleCompare() {
        if (this.filter.comparison) this.linqset.addRemovedNodesToLinqset(this.comparison)
        else this.linqset.removeRemovedNodesToLinqset()

        this.reloadTrigger = {}
    }

    async onModelSelectionOpened(event:{open:boolean, selection:ItemSelection[]}) {
        if (!event.open) {
            // closing
            this.filter.modelFunctions = []
            this.filter.modelKeys = []
            this.filter.modelTags = []

            event.selection.forEach(i => {
                switch (i.item.parentKey) {
                    case "functions":
                        this.filter.modelFunctions.push(i.item._key as MODEL_FUNCTION)
                        break
                    case "models":
                    case "changed":
                        this.filter.modelKeys.push(i.item._key)
                        break
                    case "tags":
                        this.filter.modelTags.push(i.item._key)
                        break
                }
            })
            this.runFilter()
        }
    }

    getSuperTypeName() {
        return getTypeName(this.filter.nodeType)
    }

    // selects a node type. populate node selections based on selected type and models
    selectType(selection:NodeInsightsTypeData)
    {
        this.filter.nodeType = selection?selection.type:undefined
        this.groupedNodes = []
        this.nodes = []
        this.selectedNodes = []

        if (!selection) return

        if (this.linqset.modelKeys.length > 0 && (this.filter.nodeType === NODE_TYPE.OUTCOMES || this.filter.nodeType === NODE_TYPE.CAPTURE)) {
            this.linqset.modelKeys.forEach(mk => {
                const c = selection.nodes.filter(n => n.modelKey === mk).map(n => {return new GroupItem(n._key, mk, n.name, undefined, this.filter.nodeKeys.indexOf(n._key) >= 0, n.type)})
                const model = this.organisation.models.find(m => m._key === mk)

                this.groupedNodes.push(new GroupItem(mk, undefined, model?.name, undefined, false, NODE_TYPE.MODEL, c))
            })
        }else {
            this.nodes = selection.nodes.sort((a,b) => a.name?.toLowerCase() < b.name?.toLowerCase()?-1:1)
            this.selectedNodes = this.filter.nodeKeys.length > 0?this.nodes.filter(n => this.filter.nodeKeys.indexOf(n._key) >= 0):[]
        }
    }

    // capture or outcome nodes.
    // choosing None clears the node filter
    onGroupedNodeChange(selection:ItemSelection|undefined) {
        this.tagSelection.clearSelection()
        this.filter.nodeKeys = selection ? [selection.item._key] : []
        this.runFilter()
    }

    async onStartingNodeChange(open:boolean) {

        if (!open && this.nodeSelectionChanged) {
            this.clearInformationAssetSelection()
            this.clearTagSelection()
            this.filter.nodeKeys = this.selectedNodes.map(n => n._key)
            this.runFilter()
            this.nodeSelectionChanged = false
        }
    }

    onNodeSelectionChange(event:any) {
        this.nodeSelectionChanged = true
    }

    clearNodeSelection() {
        this.filter.nodeKeys = []
        this.filter.nodeType = undefined
        this.groupedNodes = []
        this.nodes = []
    }

    clearInformationAssetSelection() {
        this.informationAssetKey = undefined
        this.filter.informationAssetKeys = []
    }

    clearTagSelection() {
        this.tagSelection.clearSelection()
        this.filter.nodeTags = []
    }

    async onInformationAssetChange(assetKey:string) {
        this.clearNodeSelection()
        this.clearTagSelection()
        this.filter.informationAssetKeys = assetKey? [assetKey]:[]
        this.runFilter()
    }

    onTagSelectionOpened(event:{open:boolean, selection:ItemSelection[]}) {
        if (!event.open) {
            this.clearInformationAssetSelection()

            this.filter.nodeTags = event.selection.map(s => s.item._key)
            this.runFilter()
        }
    }

    getSelectedNodeNames() {
        return this.selectedNodes.map(n => n.name).join(", ")
    }

    async saveFilter() {
        if (!this.filter.name?.trim() || !this.canChangeFilter()) return
        this.filter.name = this.filter.name.trim()

        // the overview's section choices and comments are only there once that tab has been opened
        if (this.insightsOverview) {
            this.filter.sections = this.insightsOverview.sectionOptions
            this.filter.fields = this.insightsOverview.filterOptions
            this.filter.comments = this.insightsOverview.sections.map(s => {return {section:s.type, comment:s.comment}})
        }

        const saved = await this.organisationService.saveInsightsFilter(this.filter)
        if (!saved) return
        this.filter._key = saved._key
        this.filter.owner = saved.owner
        this.filterUrl = this.createFilterUrl(saved)
        this.setupFilters()
    }

    async deleteFilter() {
        if (!this.isSavedFilter() || !this.canChangeFilter()) return
        const message = `Delete the saved filter ${this.filter.name}?${this.filter.private ? '' : ' It is shared, so it will be removed for everyone in the organisation.'}`
        const dialogData = new ConfirmDialogModel("Delete filter", [message], undefined, false, "Delete", "Cancel")
        const result = await lastValueFrom(this.dialog.open(ConfirmDialogComponent, { maxWidth: "420px", data: dialogData }).afterClosed())
        if (result?.button !== "Delete") return

        if (await this.organisationService.deleteInsightsFilter(this.filter)) {
            // keep the current view, as a new unsaved filter
            this.filter = {...this.filter, _key: '', name: '', owner: this.user._key}
            this.filterUrl = ''
            this.filterSelection.clearSelection()
            this.setupFilters()
        }
    }

    async runFilter(processModel:boolean=false) {
        this.loading = true
        try {
            let newLinqset = createLinqset(this.organisation, this.filter)
            let newModelType = newLinqset.defaultModelType

            let newComparison = undefined

            const compareFilter = (this.filter.workspaceKey !== CURRENT_STATE_PROJECT_KEY)?cloneInsightsfilter(this.filter, CURRENT_STATE_PROJECT_KEY):undefined

            if (newLinqset.type === LINQSET_TYPE.ORGANISATION) {
                // organisation view
                newLinqset = this.linqsetRepo.organisationLinqset

                if (this.filter.workspaceKey !== CURRENT_STATE_PROJECT_KEY) {
                    newComparison = this.linqsetRepo.currentStateOrganisationLinqset
                }

            }else if (newLinqset.type === LINQSET_TYPE.MODEL) {
                // single model selected so load that model graph
                const graphData = await this.linqsetRepo.loadModelGraph(this.organisation._key, newLinqset.modelKey, this.filter.workspaceKey)

                newLinqset = createLinqset(this.organisation, this.filter, graphData, this.linqsetRepo.organisationLinqset.nodes)
                if (processModel) processLinqset(newLinqset, this.linqsetRepo.organisationLinqset, true, this.organisation)

                if (compareFilter && newLinqset.model.projectKey === CURRENT_STATE_PROJECT_KEY) {
                    newComparison = createLinqset(this.organisation, compareFilter, graphData, this.linqsetRepo.currentStateOrganisationLinqset.nodes)
                    if (processModel) processLinqset(newComparison, this.linqsetRepo.currentStateOrganisationLinqset, true, this.organisation)
                }


            }else if (newLinqset.type === LINQSET_TYPE.MODEL_FILTER) {
                // multiple models selected so only include nodes from models in selection
                const nodes = this.filterNodesForLinqset(this.linqsetRepo.organisationLinqset, newLinqset.modelKeys, newLinqset.workspaceKey, this.linqsetRepo.currentStateOrganisationLinqset)
                newLinqset = createLinqset(this.organisation, this.filter, {nodes, edges:this.linqsetRepo.organisationLinqset.edges}, [])

                if (compareFilter) {
                    const comparisonNodes = this.filterNodesForLinqset(this.linqsetRepo.currentStateOrganisationLinqset, newLinqset.modelKeys, CURRENT_STATE_PROJECT_KEY, this.linqsetRepo.organisationLinqset)
                    newComparison = createLinqset(this.organisation, compareFilter, {nodes:comparisonNodes, edges:this.linqsetRepo.currentStateOrganisationLinqset.edges}, [])
                    newLinqset.model.insights.push(newComparison.insights)
                    newComparison.model.insights.push(newLinqset.insights)
                }
            }else if (newLinqset.type === LINQSET_TYPE.NODE_FILTER) {
                // load data from backend based on selected node or information asset

                if (this.filter.nodeType && isOrganisationNode(getSuperType(this.filter.nodeType))) newModelType = MODEL_TYPE.SINGLE_NODE

                const graphData = await this.insightsService.loadGraphForFilter(this.organisation, this.filter)
                newLinqset = createLinqset(this.organisation, this.filter, graphData, this.linqsetRepo.organisationLinqset.nodes)

                if (compareFilter && newLinqset.model.projectKey === CURRENT_STATE_PROJECT_KEY) {
                    newComparison = createLinqset(this.organisation, compareFilter, graphData, this.linqsetRepo.currentStateOrganisationLinqset.nodes)
                    newLinqset.model.insights.push(newComparison.insights)
                    newComparison.model.insights.push(newLinqset.insights)
                }
            }

            newLinqset.readonlyOverride = true

            await this.dataLoaded(newModelType, newLinqset, newComparison)

        }finally {
            this.loading = false
        }
    }

    private filterNodesForLinqset(linqset:Linqset, modelKeys:string[], projectKey:string, linqset2?:Linqset) {
        return filterNodesForLinqset(linqset, modelKeys, projectKey, linqset2)
    }

    private async dataLoaded(newModelType:MODEL_TYPE, newLinqset:Linqset, newComparison:Linqset) {
        if (newLinqset) {
            const group = this.filter.nodeTags.length > 0 && findTagForOrganisation(this.organisation, this.filter.nodeTags[0])
            this.labelService.tagGroup = group?.group

            this.modelType = newModelType

            if (this.filter.comparison) newLinqset.addRemovedNodesToLinqset(newComparison)

            this.loading = false
            this.linqset = newLinqset
            this.comparison = newComparison
            this.setTypeData()

            this.reloadTrigger = {}
        }
    }

}
